import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { sseClient } from '#pplx_generated/typespec/rest/sse/client.js';
/**
 * Send user response to a blocking event (Canvas confirmation, browser agent permission, etc.)
 */
export const postBlockingEventResponse = async (response) => {
    try {
        const { data, error, response: resp, } = await sseClient.POST('/rest/sse/blocking_event_response', 'send blocking event response', {
            body: { response },
            timeoutMs: getQueryTimeoutMs(),
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: resp.status ?? 0,
            });
        }
        // CompletedResponse has status="completed", FailedResponse has status="failed"
        return data?.status === 'completed';
    }
    catch (error) {
        logger.error('Error sending blocking event response', {
            error,
            response,
        });
        return false;
    }
};
//# sourceMappingURL=postBlockingEventResponse.js.map